import React from 'react';
import SnowLevelChart from './SnowLevelChart';
import Typography from '@mui/material/Typography';
import { Stack, Box, Link } from '@mui/material';
import { useForecast } from '../hooks/forecast';

export default function Location({ location, xAxisPosition }) {
  const forecast = useForecast(location);

  if (!forecast.isLoading && !forecast.isError) {
    return (
      <Stack
        direction="row"
        sx={{
          '&:hover .MuiTypography-root.bold-on-hover': {
            fontWeight: 500,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: 150,
            justifyContent: 'flex-start',
            paddingTop: 2.5,
            paddingBottom: 2.5,
            paddingLeft: 2.5,
          }}
        >
          <Box>
            <Typography variant="body2" align="left" className="bold-on-hover">
              {location.name}
            </Typography>

            <Stack direction="row" gap={0.5}>
              <Link
                href={location.noaaLink}
                underline="none"
                sx={{ fontSize: 12 }}
              >
                NOAA
              </Link>

              <Link
                href={location.nwacLink}
                underline="none"
                sx={{ fontSize: 12 }}
              >
                NWAC
              </Link>
            </Stack>
          </Box>
        </Box>

        <SnowLevelChart
          forecast={forecast}
          location={location}
          xAxisPosition={xAxisPosition}
        />
      </Stack>
    );
  }
}
